import { getWorkPolicy } from '../../api/hr-schedule';

/**
 * ⭐ 2026-10-20 — 하루종일 일정의 시각 = 내 **근태 시간**(출근 ~ 퇴근). 사용자 결정:
 *   「하루종일 일정은 근태 시간이야. 출근시간부터 퇴근시간까지」.
 *
 * 근태 화면이 쓰는 `GET /hr/attendance/policy?date=` 그대로다(교대 편성 → 개인 → 팀 → 회사 기본 근무제 → 09:00~18:00).
 *   시작 = 시작 날의 출근 시각, 종료 = 끝 날의 퇴근 시각. 서버도 저장 때 «작성자» 기준으로 같은 규칙으로 맞추므로
 *   (calendar-allday-hours.ts) 여기 값은 창에서 미리 보이는 값이다.
 *
 * 물러서는 값 09:00 ~ 18:00 — 정책을 못 읽었을 때 · 하루짜리인데 퇴근이 출근보다 앞일 때(야간조는 그날 23:59 로 끊는다).
 */
export const ALL_DAY_FALLBACK = { start: '09:00', end: '18:00' } as const;

/** 근무 정책 시각이 `HH:mm`(00:00 ~ 23:59) 인가 — 유형별 추천 시간(type-time-presets.ts)도 같은 검사를 쓴다. */
export const HHMM = /^([01]\d|2[0-3]):[0-5]\d$/;

export async function allDayWorkHours(startDate: string, endDate: string): Promise<{ start: string; end: string }> {
  try {
    const [ps, pe] = await Promise.all([
      getWorkPolicy(startDate),
      startDate === endDate ? null : getWorkPolicy(endDate),
    ]);
    const start = ps.baseStart;
    let end = (pe ?? ps).baseEnd;
    if (!HHMM.test(start ?? '') || !HHMM.test(end ?? '')) return { ...ALL_DAY_FALLBACK };
    // 같은 날 퇴근이 출근보다 앞 = 자정을 넘는 야간조 — 그날 23:59 에서 끊는다(서버와 같다).
    if (startDate === endDate && end <= start) end = '23:59';
    return { start, end };
  } catch {
    return { ...ALL_DAY_FALLBACK };
  }
}
